import { I18n } from 'react-redux-i18n';

const terminalSearchFields = (searchFieldValues, entityList, profileList) => {
    return {
        rows: [
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "terminalIdentifier",
                        label: I18n.t("terminals.list.terminalId"),
                        type: "text",
                        value: searchFieldValues.terminalIdentifier.value,
                    },
                    {
                        id: "entityId",
                        label: I18n.t("terminals.list.entity"),
                        type: "dropdown",
                        value: searchFieldValues.entityId.value,
                        data: entityList,
                        validator: () => { }
                    },
                    {
                        id: "terminalProfile",
                        label: I18n.t("terminals.list.profile"),
                        type: "dropdown",
                        value: searchFieldValues.terminalProfile.value,
                        data: profileList,
                        validator: () => { }
                    },
                ]
            },
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "name",
                        label: I18n.t("terminals.list.name"),
                        type: "text",
                        value: searchFieldValues.name.value,
                    },
                    {
                        id: "status",
                        label: I18n.t("terminals.list.status"),
                        type: "dropdown",
                        value: searchFieldValues.status.value,
                        data: [{value: "ENABLED", label: I18n.t("terminals.status.enabled")}, {value: "DISABLED", label: I18n.t("terminals.status.disabled")}],
                        validator: () => { }
                    },
                ]
            }
        ]
    }
};

export {
    terminalSearchFields
}